import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr2002',
    ecrans: ['00-2'],
    params: ['id', 'enacleint', '?indfor']
});
